import { MarketCode } from '../@types/MarketCode';

// Receive registration number identifier used in input fields based on current market

export const getRegistrationNumberIdentifier = (market: MarketCode) => {
  switch (market) {
    case 'SE':
      return `
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 34" aria-hidden="true">
          <rect width="22" height="34" rx="1" fill="#458BDD" />
          <circle cx="11" cy="10" r="5.5" stroke="#FFF500" strokelinejoin="round" strokedasharray="1 2" />
          <path d="M10.6707 21.692c1.392 0 2.04.564 2.28.996h1.644c-.264-1.08-1.248-2.364-3.924-2.364-2.028 0-3.408.912-3.408 2.436 0 1.536 1.2 2.34 2.904 2.508l1.512.156c.876.108 1.476.372 1.476 1.188 0 .684-.684 1.176-1.98 1.176-1.56 0-2.244-.72-2.472-1.26h-1.716c.336 1.224 1.404 2.628 4.188 2.628 2.412 0 3.624-1.116 3.624-2.652 0-1.8-1.308-2.448-3.012-2.616-.576-.06-.972-.108-1.5-.156-.888-.108-1.392-.444-1.392-1.02 0-.624.612-1.02 1.776-1.02Z" fill="#fff" />
        </svg>
      `;
    case 'NO':
      return `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 34" width="22" height="34" fill="none" aria-hidden="true">
          <path fill="#0046A6" d="M21 0H1a1 1 0 0 0-1 1v32a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1Z" />
          <path fill="#fff" d="M8.92 29v-5.64L12.664 29h1.92v-8.88h-1.92v5.652L8.92 20.12H7V29h1.92Z" />
          <g>
            <path fill="#FF4840" d="M3 4h16v12H3z" />
            <path fill="#fff" d="M7 4h4v12H7z" />
            <path fill="#fff" d="M3 8h16v4H3z" />
            <path fill="#00377A" d="M8 4h2v12H8z" />
            <path fill="#00377A" d="M3 11h16V9H3z" />
          </g>
        </svg>
      `;
    default:
      return '';
  }
};
